import React from 'react';
import { BookOpen } from 'lucide-react';

interface NavbarBrandProps {
  onSelectTab: (tab: 'landing') => void;
}

export const NavbarBrand: React.FC<NavbarBrandProps> = ({ onSelectTab }) => {
  return (
    <button
      id="brand-logo"
      type="button"
      onClick={() => onSelectTab('landing')}
      className="flex items-center gap-2.5 text-left group cursor-pointer"
    >
      <div className="w-10 h-10 rounded-xl bg-linear-to-tr from-indigo-700 to-indigo-500 text-white flex items-center justify-center shadow-md shadow-indigo-600/20 group-hover:scale-105 transition">
        <BookOpen className="w-5 h-5" />
      </div>
      <div>
        <span className="font-extrabold text-xl text-slate-900 tracking-tight leading-none flex items-center gap-1">
          UIBN <span className="text-xs font-semibold text-indigo-600 bg-indigo-50 px-1.5 py-0.5 rounded">ID</span>
        </span>
      </div>
    </button>
  );
};
